import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import CheckIcon from '@mui/icons-material/Check';

import {setLookActiveCategory, setLookMoreInfoOpened} from "../../../../../actions/lookFunctions";
import MaterialSpinner from "../../../../ui/materialSpinner";
import {updateCanvasCount} from "../../../../../actions/actionFunctions";
import GroheRequiredFeatures from "./groheRequiredFeatures";
import {getLixilRequiredNotIncludedFeatures} from "../groheFunctions";
import GroheFeatureMoreInfoButton from "./groheFeatureMoreInfoButton";

const GroheFeatureContentInCart = (props) => {

  const [requiredFeatures, setRequiredFeatures] = useState(null);
  const {lookActiveFeature, selection} = props;
  useEffect(() => {
    setRequiredFeatures(getLixilRequiredNotIncludedFeatures(lookActiveFeature))
  },[lookActiveFeature, setRequiredFeatures])

  if (!lookActiveFeature) {
    if (selection) {
      return <MaterialSpinner/>
    }
    return null
  }

  return (
    <div className="grohe-feature__content-in-cart">
      <div className="lk-title">
        <h2 className="lk-title__text bold grohe-icontext">
          <CheckIcon fontSize="small"/><span className="grohe-icontext__cell"><FormattedMessage id="grohe.feature.addingToCartSuccessfull" /></span>
        </h2>
      </div>
      <div className="grohe-feature__content-info">
        <GroheFeatureMoreInfoButton/>
      </div>
      <div className="lm-feature__content-description">
        {Array.isArray(requiredFeatures) && requiredFeatures.length
          ? <GroheRequiredFeatures requiredFeatures={requiredFeatures}/>
          : null}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookActiveCategory} = store.lookState;
  return {
    lookActiveFeature,
    lookActiveCategory,
  };
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setLookMoreInfoOpened,
  updateCanvasCount,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheFeatureContentInCart)
